import React, { useState, useEffect,useContext, useRef } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  ClickAwayListener,
  Rating,
} from "@mui/material";
import menustar from "../images/menustar.png";
import callingicon from "../images/callingicon.png";
import INSTAGRAM from "../images/INSTAGRAM.png";
import google from "../images/google.png";
import TIKTOK from "../images/TIKTOK.png";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LanguageIcon from "@mui/icons-material/Language";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import StarIcon from "@mui/icons-material/Star";
import CircleIcon from "@mui/icons-material/Circle";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import PublicIcon from "@mui/icons-material/Public";
import nexticon from "../images/nexticon.png";
import TelegramIcon from "@mui/icons-material/Telegram";
import TwitterIcon from "@mui/icons-material/Twitter";
import call from "../images/call.png";
import axiosInstance from "./axios";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment-timezone";
import { BusinessContext } from "./BusinessContext";
import PhoneIcon from "@mui/icons-material/Phone";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ShareIcon from "@mui/icons-material/Share";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import DownloadIcon from "@mui/icons-material/Download";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import { useTranslation } from "react-i18next";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/FirebaseConfig";

const grouplogo = `${process.env.PUBLIC_URL}/Grouplogo.png`;
const appIcon = `${process.env.PUBLIC_URL}/icon512.png`;

const POINTGENIE_IOS_APP_URL =
  "https://apps.apple.com/us/app/pointgenie-pox-live-places/id6757905616";
const POINTGENIE_ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.pointgenie.app";
const POINTGENIE_BRANCH_APP_LINK =
  process.env.REACT_APP_BRANCH_APP_LINK || "https://1l2a6.app.link/tag_scan";

function getPointGenieAppPlatform() {
  const userAgent = window.navigator.userAgent || "";
  if (/Android/i.test(userAgent)) return "android";
  if (/iPad|iPhone|iPod/.test(userAgent)) return "ios";
  return "desktop";
}

function getBusinessIdValue(business, fallbackBusinessId) {
  return fallbackBusinessId || business?.id || business?.business_id || "";
}

function getPlaceIdValue(business, fallbackPlaceId) {
  return (
    fallbackPlaceId ||
    business?.place_id ||
    business?.google_place_id ||
    business?.provider_id ||
    ""
  );
}

function buildPointGenieAppLink({
  plateCode,
  businessId,
  placeId,
  pendingAction = "view_place",
}) {
  const baseUrl =
    (POINTGENIE_BRANCH_APP_LINK || "").trim() ||
    "https://1l2a6.app.link/tag_scan";
  const hasBusinessContext = Boolean(plateCode || businessId || placeId);

  if (!hasBusinessContext) {
    return baseUrl;
  }

  try {
    const url = new URL(baseUrl);
    url.searchParams.set("source", "tag_scan");
    url.searchParams.set("campaign", "web_scan_conversion");
    url.searchParams.set("pending_action", pendingAction);

    if (plateCode) url.searchParams.set("plate_code", plateCode);
    if (businessId) url.searchParams.set("business_id", String(businessId));
    if (placeId) url.searchParams.set("place_id", String(placeId));

    return url.toString();
  } catch (error) {
    const params = new URLSearchParams();
    params.set("source", "tag_scan");
    params.set("campaign", "web_scan_conversion");
    params.set("pending_action", pendingAction);
    if (plateCode) params.set("plate_code", plateCode);
    if (businessId) params.set("business_id", String(businessId));
    if (placeId) params.set("place_id", String(placeId));

    return `https://1l2a6.app.link/tag_scan?${params.toString()}`;
  }
}

function trackPointGenieAppEvent(eventName, payload) {
  try {
    logEvent(analytics, eventName, payload);
  } catch (error) {
    console.warn("PointGenie app CTA analytics failed", error);
  }
}

function LandingPage() {
  const navigate = useNavigate();
  const { code } = useParams();

  const [getBusinessData, setGetBusinessData] = useState({});

  const [placeId, setPlaceId] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [validImages, setValidImages] = useState([]);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalPageLoading, setTotalPageLoading] = useState(false);
  const [businessId, setBusinessId] = useState(null);
  const isMobile = useMediaQuery("(max-width:500px)");
  const muiTheme = useTheme();
  const { categoriesData } = useContext(BusinessContext);
  const currentUrl = window.location.href;
  const {t} = useTranslation();
  const appCtaViewTrackedRef = useRef(false);

  useEffect(() => {
    const fetchBusinessData = async () => {
      // setLoading(true);
      setTotalPageLoading(true);
      try {
        const response = await axiosInstance.post(
          "payments.php?method=fetch_business",
          { plate_code: code }
        );
        if (
          response.data?.status === "success" &&
          response.data?.place_details
        ) {
          setGetBusinessData(response.data.place_details);
          setValidImages(response.data.place_details.images || []);
          setBusinessId(response.data.id);
        } else {
          console.error("Invalid API response structure:", response.data);
        }
        const fetchedPlaceId = response.data?.place_details?.place_id;
        if (fetchedPlaceId) {
          setPlaceId(fetchedPlaceId);
        }

        // Convert images to valid URLs
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        // setLoading(false);
        setTotalPageLoading(false);
      }
    };

    fetchBusinessData();
  }, [code]);

  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX - touchEndX > 50) {
      // Swipe Left (Next Image)
      setCurrentImageIndex(
        (prev) => (prev + 1) % getBusinessData?.images?.length
      );
    } else if (touchStartX - touchEndX < -50) {
      // Swipe Right (Previous Image)
      setCurrentImageIndex((prev) =>
        prev === 0 ? getBusinessData?.images?.length - 1 : prev - 1
      );
    }
  };

  // Function to navigate images
  const handleImageNavigation = (direction) => {
    if (validImages.length === 0) return;

    setCurrentImageIndex((prev) =>
      direction === "next"
        ? (prev + 1) % validImages.length
        : (prev - 1 + validImages.length) % validImages.length
    );
  };

  // Function to generate valid image URLs
  // const getValidImageUrls = (images) => {
  //   return images
  //     ?.filter((img) => img && img !== null && img.trim() !== "") // Remove empty/null values
  //     .map(
  //       (photoRef) =>
  //         `https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photo_reference=${photoRef}&key=${API_KEY}`
  //     );
  // };

  // Opens the dropdown when the icon is clicked
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Closes the dropdown manually
  const handleClosesocialmedia = () => {
    setAnchorEl(null);
  };

  // Handle social media click (share URL)
  const handleSocialClick = (platform) => {
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/`; // Instagram doesn't allow direct text sharing
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      default:
        break;
    }

    // Open the share URL in a new tab
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }

    // Close the dropdown after clicking
    handleClosesocialmedia();
  };



  const handleProviderClick = async (item) => {
    if (item.provider.toLowerCase() === "whatsapp") {
      const whatsappUrl = `https://wa.me/${item.providerUrl.replace(/\D/g, "")}`;
      window.open(whatsappUrl, "_blank");
    } else {
      const finalUrl = item.providerUrl.startsWith("http")
        ? item.providerUrl
        : `https://${item.providerUrl}`;
      window.open(finalUrl, "_blank");
    }
    try {
      await axiosInstance.post("payments.php?method=provider_clicks", {
        business_id: businessId,
        provider: item.provider,
      });
    } catch (error) {
      console.error("providerclicking failed", error);
    }
  };


  const handleGoogleProviderClick = async () => {
    const fallbackUrl = getBusinessData?.provider?.google?.proivder_link;  
    const url = fallbackUrl ;

  if (!url) return; // Do nothing if no valid URL

    window.open(url, "_blank");
    try {
      await axiosInstance.post("payments.php?method=provider_clicks", {
        business_id: businessId,
        provider: "google",
      });
    } catch (error) {
      console.error("providerclicking failed", error);
    }
  };

  const  formatReviewCount= (count) =>{
    if (!count && count !== 0) return '';
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    }
    return count;
  }

  const appCtaBusinessId = getBusinessIdValue(getBusinessData, businessId);
  const appCtaPlaceId = getPlaceIdValue(getBusinessData, placeId);
  const pointGenieAppLink = buildPointGenieAppLink({
    plateCode: code,
    businessId: appCtaBusinessId,
    placeId: appCtaPlaceId,
  });

  const handlePointGenieAppClick = () => {
    const appLink = pointGenieAppLink;

    trackPointGenieAppEvent("app_cta_clicked", {
      plate_code: code || "",
      business_id: String(getBusinessIdValue(getBusinessData, businessId) || ""),
      place_id: String(getPlaceIdValue(getBusinessData, placeId) || ""),
      source: "tag_scan",
      campaign: "web_scan_conversion",
      platform: getPointGenieAppPlatform(),
    });
    trackPointGenieAppEvent("open_in_pointgenie_clicked", {
      plate_code: code || "",
      business_id: String(getBusinessIdValue(getBusinessData, businessId) || ""),
      place_id: String(getPlaceIdValue(getBusinessData, placeId) || ""),
      source: "tag_scan",
      campaign: "web_scan_conversion",
      platform: getPointGenieAppPlatform(),
    });

    if (appLink) {
      window.location.href = appLink;
      return;
    }

    const userAgent = window.navigator.userAgent || "";
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const storeUrl = isAndroid
      ? POINTGENIE_ANDROID_APP_URL
      : POINTGENIE_IOS_APP_URL;

    if (!isIOS && !isAndroid) {
      window.open("https://www.pointgenie.com/", "_blank", "noopener,noreferrer");
      return;
    }
    window.location.href = storeUrl;
  };

  const themeColors = muiTheme.palette.pointGenie;
  const palette = {
    bg: themeColors.bg,
    bgStart: themeColors.bgStart,
    bgEnd: themeColors.bgEnd,
    card: themeColors.card,
    surfaceMuted: themeColors.surfaceMuted,
    border: themeColors.border,
    textPrimary: themeColors.text,
    textSecondary: themeColors.text2,
    textMuted: themeColors.textMuted,
    textDim: themeColors.textDim,
    accent: themeColors.accent,
    accentDark: themeColors.primary,
    accentBlue: themeColors.accentBlue,
    accentBlueBg: themeColors.accentBlueBg,
    success: themeColors.success,
    successMuted: themeColors.successMuted,
    onAccent: themeColors.onAccent,
    overlayButton:
      muiTheme.palette.mode === "dark"
        ? "rgba(15,23,42,0.88)"
        : "rgba(255,255,255,0.92)",
    overlayButtonHover:
      muiTheme.palette.mode === "dark"
        ? "rgba(30,41,59,0.96)"
        : "#FFFFFF",
    shadow:
      muiTheme.palette.mode === "dark"
        ? "0 18px 44px rgba(0, 0, 0, 0.28)"
        : "0 18px 44px rgba(15, 23, 42, 0.10)",
  };

  const imageUrls = (getBusinessData?.images || []).filter((img) => img && img !== "");
  const activeImage = imageUrls[currentImageIndex] || "";
  const hasRating = getBusinessData?.rating !== undefined && getBusinessData?.rating !== null && getBusinessData?.rating !== "";
  const reviewCount = formatReviewCount(getBusinessData?.review_count);

  useEffect(() => {
    if (appCtaViewTrackedRef.current) return;
    if (!getBusinessData?.name && !appCtaBusinessId && !appCtaPlaceId) return;

    trackPointGenieAppEvent("app_cta_viewed", {
      plate_code: code || "",
      business_id: String(appCtaBusinessId || ""),
      place_id: String(appCtaPlaceId || ""),
      source: "tag_scan",
      campaign: "web_scan_conversion",
      platform: getPointGenieAppPlatform(),
    });
    appCtaViewTrackedRef.current = true;
  }, [code, appCtaBusinessId, appCtaPlaceId, getBusinessData?.name]);

  const normalizedWebsite = getBusinessData?.website
    ? /^https?:\/\//i.test(getBusinessData.website)
      ? getBusinessData.website
      : `https://${getBusinessData.website}`
    : "";
  const openMapsUrl = getBusinessData?.address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        getBusinessData.address
      )}`
    : "";
  const utilityDetails = [
    getBusinessData?.address && {
      icon: <LocationOnIcon sx={{ fontSize: 20, color: palette.textSecondary }} />,
      title: t("Address"),
      subtitle: getBusinessData.address,
      url: openMapsUrl,
    },
    getBusinessData?.telephone && {
      icon: <PhoneIcon sx={{ fontSize: 20, color: palette.textSecondary }} />,
      title: t("Phone"),
      subtitle: getBusinessData.telephone,
      url: `tel:${getBusinessData.telephone}`,
    },
    normalizedWebsite && {
      icon: <LanguageIcon sx={{ fontSize: 20, color: palette.textSecondary }} />,
      title: t("Website"),
      subtitle: getBusinessData.website,
      url: normalizedWebsite,
    },
  ].filter(Boolean);

  const providerItems = getBusinessData?.provider
    ? Object.entries(getBusinessData.provider)
        .filter(
          ([provider, data]) =>
            data.proivder_link && provider.toLowerCase() !== "google"
        )
        .map(([provider, data]) => {
          let providerIcon;
          let providerName = data.proivder_label;
          let providerUrl = data.proivder_link;

          if (provider.toLowerCase() === "yelp") {
            providerIcon = <StarIcon sx={{ color: "#D32323", fontSize: 24 }} />;
          } else if (provider.startsWith("customprovider_")) {
            providerIcon = <InsertLinkIcon sx={{ color: palette.accent, fontSize: 24 }} />;
          } else {
            switch (provider.toLowerCase()) {
              case "facebook":
                providerIcon = <FacebookIcon sx={{ color: "#1877F2", fontSize: 24 }} />;
                break;
              case "instagram":
                providerIcon = <InstagramIcon sx={{ color: "#E4405F", fontSize: 24 }} />;
                break;
              case "tiktok":
                providerIcon = (
                  <Box component="img" src={TIKTOK} sx={{ width: 24, height: 24 }} />
                );
                break;
              case "whatsapp":
                providerIcon = <WhatsAppIcon sx={{ color: "#25D366", fontSize: 24 }} />;
                break;
              case "tripadvisor":
                providerIcon = <StarIcon sx={{ color: "#00AF87", fontSize: 24 }} />;
                break;
              case "pointgenie":
                providerIcon = (
                  <Box component="img" src={grouplogo} sx={{ width: 24, height: 24 }} />
                );
                break;
              default:
                return null;
            }
          }

          return { provider, providerUrl, providerIcon, providerName };
        })
        .filter(Boolean)
    : [];

  const renderLandingContent = () => (
    <Box sx={{ minHeight: "100vh", backgroundColor: palette.bg, pb: 4 }}>
      <Box sx={{ width: "100%", maxWidth: "560px", mx: "auto", backgroundColor: palette.bg }}>
        <Box
          sx={{
            width: "100%",
            height: { xs: 240, sm: 300 },
            position: "relative",
            backgroundColor: palette.surfaceMuted,
            overflow: "hidden",
          }}
        >
          {activeImage ? (
            <Box
              component="img"
              src={activeImage}
              sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box component="img" src={grouplogo} alt="PointGenie" sx={{ width: 88, height: 88, opacity: 0.75 }} />
            </Box>
          )}

          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.02) 42%, rgba(0,0,0,0.32) 100%)",
              pointerEvents: "none",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              top: 18,
              left: 14,
              right: 14,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: palette.overlayButton,
                color: palette.textPrimary,
                boxShadow: palette.shadow,
                "&:hover": { backgroundColor: palette.overlayButtonHover },
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: 18, ml: "4px" }} />
            </IconButton>
            <IconButton
              onClick={handleClick}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: palette.overlayButton,
                color: palette.textPrimary,
                boxShadow: palette.shadow,
                "&:hover": { backgroundColor: palette.overlayButtonHover },
              }}
            >
              <ShareIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Box>

          {imageUrls.length > 1 && (
            <>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: 0,
                  right: 0,
                  display: isMobile ? "none" : "flex",
                  justifyContent: "space-between",
                  px: 2,
                  transform: "translateY(-50%)",
                }}
              >
                <IconButton onClick={() => handleImageNavigation("prev")} sx={{ backgroundColor: palette.overlayButton, color: palette.textPrimary, "&:hover": { backgroundColor: palette.overlayButtonHover } }}>
                  <ArrowBackIosIcon sx={{ fontSize: 18 }} />
                </IconButton>
                <IconButton onClick={() => handleImageNavigation("next")} sx={{ backgroundColor: palette.overlayButton, color: palette.textPrimary, "&:hover": { backgroundColor: palette.overlayButtonHover } }}>
                  <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
              <Box sx={{ position: "absolute", bottom: 16, left: 0, right: 0, display: "flex", justifyContent: "center", gap: 1 }}>
                {imageUrls.map((_, index) => (
                  <CircleIcon
                    key={index}
                    sx={{ fontSize: 8, color: index === currentImageIndex ? "#fff" : "rgba(255,255,255,0.58)", cursor: "pointer" }}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </Box>
            </>
          )}

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClosesocialmedia}
            PaperProps={{ sx: { mt: 1, borderRadius: "14px", backgroundColor: palette.card, color: palette.textPrimary, border: `1px solid ${palette.border}`, boxShadow: palette.shadow, width: "200px", p: "5px" } }}
          >
            <MenuItem onClick={() => handleSocialClick("whatsapp")} sx={{ gap: 1 }}>
              <WhatsAppIcon sx={{ color: "#25D366" }} />
              <Typography>WhatsApp</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleSocialClick("instagram")} sx={{ gap: 1 }}>
              <InstagramIcon sx={{ color: "#E4405F" }} />
              <Typography>Instagram</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleSocialClick("facebook")} sx={{ gap: 1 }}>
              <FacebookIcon sx={{ color: "#1877F2" }} />
              <Typography>Facebook</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleSocialClick("twitter")} sx={{ gap: 1 }}>
              <TwitterIcon sx={{ color: "#1DA1F2" }} />
              <Typography>Twitter</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleSocialClick("telegram")} sx={{ gap: 1 }}>
              <TelegramIcon sx={{ color: "#0088CC" }} />
              <Typography>Telegram</Typography>
            </MenuItem>
          </Menu>
        </Box>

        <Box sx={{ px: 2, mt: "14px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", border: `1px solid ${palette.border}`, borderRadius: "18px", backgroundColor: palette.card, p: 2 }}>
            <Typography sx={{ fontSize: "24px", fontFamily: "Roboto", fontWeight: 800, lineHeight: "29px", color: palette.textPrimary, wordBreak: "break-word" }}>
              {getBusinessData?.name || ""}
            </Typography>
            {getBusinessData?.address && (
              <Typography sx={{ fontSize: "14px", fontFamily: "Roboto", lineHeight: "20px", fontWeight: 500, color: palette.textSecondary }}>
                {getBusinessData.address}
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                {hasRating && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <StarRoundedIcon sx={{ color: "#F59E0B", fontSize: 20 }} />
                    <Typography sx={{ fontSize: "14px", fontFamily: "Roboto", fontWeight: 700, color: palette.textSecondary }}>
                      {parseFloat(getBusinessData.rating).toFixed(1)}
                    </Typography>
                  </Box>
                )}
                {reviewCount !== "" && (
                  <Typography sx={{ fontSize: "13px", fontFamily: "Roboto", fontWeight: 600, color: palette.textMuted }}>
                    {reviewCount} {t("reviews")}
                  </Typography>
                )}
              </Box>
              {getBusinessData?.start_end_time && (
                <Box sx={{ display: "flex", alignItems: "center", gap: "6px", border: `1px solid ${palette.border}`, borderRadius: "999px", px: "12px", py: "8px", backgroundColor: palette.surfaceMuted }}>
                  <AccessTimeIcon sx={{ fontSize: 16, color: palette.textMuted }} />
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, fontFamily: "Roboto", color: getBusinessData.start_end_time === "Closed" ? palette.textMuted : palette.success }}>
                    {getBusinessData.start_end_time}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ display: "flex", gap: "10px", mt: "2px" }}>
              {getBusinessData?.telephone && (
                <IconButton onClick={() => window.open(`tel:${getBusinessData.telephone}`)} sx={{ width: 44, height: 44, borderRadius: "14px", border: `1px solid ${palette.border}`, backgroundColor: palette.surfaceMuted, color: palette.textSecondary }}>
                  <PhoneIcon sx={{ fontSize: 22 }} />
                </IconButton>
              )}
              {normalizedWebsite && (
                <IconButton onClick={() => window.open(normalizedWebsite, "_blank", "noopener,noreferrer")} sx={{ width: 44, height: 44, borderRadius: "14px", border: `1px solid ${palette.border}`, backgroundColor: palette.surfaceMuted, color: palette.textSecondary }}>
                  <LanguageIcon sx={{ fontSize: 22 }} />
                </IconButton>
              )}
              {openMapsUrl && (
                <IconButton onClick={() => window.open(openMapsUrl, "_blank", "noopener,noreferrer")} sx={{ width: 44, height: 44, borderRadius: "14px", border: `1px solid ${palette.border}`, backgroundColor: palette.surfaceMuted, color: palette.textSecondary }}>
                  <LocationOnIcon sx={{ fontSize: 22 }} />
                </IconButton>
              )}
            </Box>
          </Box>
        </Box>

        {getBusinessData.business_categories > 0 && (
          <Box sx={{ px: 2, mt: "14px", display: "flex", gap: "10px" }}>
            <Button onClick={() => navigate(`/menu/${code}`)} sx={{ flex: 1, minHeight: 46, borderRadius: "16px", backgroundColor: palette.accent, color: palette.onAccent, fontSize: "14px", fontWeight: 700, fontFamily: "Roboto", textTransform: "none", "&:hover": { backgroundColor: palette.accentBlue } }}>
              {t("Check Menu")}
            </Button>
            <Button onClick={() => navigate(`/offers/${code}`)} sx={{ flex: 1, minHeight: 46, borderRadius: "16px", border: `1px solid ${palette.border}`, backgroundColor: palette.card, color: palette.textPrimary, fontSize: "14px", fontWeight: 700, fontFamily: "Roboto", textTransform: "none", "&:hover": { backgroundColor: palette.surfaceMuted } }}>
              {t("Offers")}
            </Button>
          </Box>
        )}

        {getBusinessData?.provider?.google && (
          <Box sx={{ px: 2, mt: "14px" }}>
            <Button onClick={() => handleGoogleProviderClick()} sx={{ width: "100%", minHeight: 56, borderRadius: "16px", backgroundColor: palette.accentDark, color: "#fff", fontSize: "16px", fontFamily: "Roboto", fontWeight: 800, textTransform: "none", boxShadow: "0 10px 24px rgba(0,65,168,0.22)", "&:hover": { backgroundColor: "#003487" } }}>
              <img src={google} alt="Google" style={{ width: "30px", height: "auto", marginRight: "12px" }} />
              {t("Leave us a Google Review")}
            </Button>
          </Box>
        )}

        {providerItems.length > 0 && (
          <Box sx={{ px: 2, mt: "14px" }}>
            <Typography sx={{ fontSize: "18px", fontFamily: "Roboto", fontWeight: 700, color: palette.textPrimary, mb: "10px" }}>
              {t("Connect")}
            </Typography>
            <Grid container spacing={1}>
              {providerItems.map((item) => (
                <Grid item xs={providerItems.length === 1 ? 12 : 6} key={item.provider}>
                  <Box onClick={() => handleProviderClick(item)} sx={{ minHeight: 54, border: `1px solid ${palette.border}`, borderRadius: "16px", backgroundColor: palette.card, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", cursor: "pointer", px: "10px" }}>
                    {item.providerIcon}
                    <Typography sx={{ fontSize: "14px", fontWeight: 800, fontFamily: "Roboto", color: palette.textPrimary, overflowWrap: "anywhere" }}>
                      {item.providerName}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        <Box sx={{ px: 2, mt: "14px" }}>
          <Box
            sx={{
              border: `1px solid ${palette.border}`,
              borderRadius: "24px",
              backgroundColor: palette.card,
              boxShadow: palette.shadow,
              p: { xs: "18px", sm: "22px" },
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: { xs: "14px", sm: "18px" },
            }}
          >
            <Box
              sx={{
                position: "relative",
                flex: "0 0 auto",
                alignSelf: { xs: "flex-start", sm: "center" },
              }}
            >
              <Box
                component="img"
                src={appIcon}
                alt="PointGenie app"
                sx={{
                  width: { xs: 72, sm: 78 },
                  height: { xs: 72, sm: 78 },
                  borderRadius: "19px",
                  boxShadow:
                    "0 16px 32px rgba(15, 23, 42, 0.22), 0 5px 12px rgba(37, 99, 235, 0.22)",
                  display: "block",
                  objectFit: "cover",
                }}
              />
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontFamily: "Roboto", fontWeight: 900, fontSize: "16px", lineHeight: "20px", color: palette.textPrimary }}>
                {t("PointGenie")}
              </Typography>
              <Typography sx={{ fontFamily: "Roboto", fontWeight: 900, fontSize: { xs: "21px", sm: "24px" }, lineHeight: { xs: "25px", sm: "29px" }, color: palette.textPrimary, mt: "4px" }}>
                {t("See this place live in PointGenie")}
              </Typography>
              <Typography sx={{ fontFamily: "Roboto", fontSize: "14px", lineHeight: "20px", fontWeight: 600, color: palette.textMuted, mt: "7px" }}>
                {t("Check the vibe, view live updates, discover nearby hotspots, and earn points when you check in.")}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                pl: { xs: 0, sm: "16px" },
                borderLeft: { xs: "none", sm: `1px solid ${palette.border}` },
                flex: { xs: "1 0 100%", sm: "0 0 auto" },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Button
                onClick={handlePointGenieAppClick}
                sx={{
                  minHeight: 48,
                  borderRadius: "16px",
                  background: "linear-gradient(180deg, #2378FF 0%, #075DE8 100%)",
                  color: "#fff",
                  fontFamily: "Roboto",
                  fontWeight: 900,
                  fontSize: "15px",
                  textTransform: "none",
                  px: { xs: "14px", sm: "20px" },
                  width: { xs: "100%", sm: "auto" },
                  boxShadow: "0 10px 24px rgba(0, 95, 232, 0.28)",
                  whiteSpace: "nowrap",
                  "&:hover": { background: "linear-gradient(180deg, #1F6FEF 0%, #0555D4 100%)" },
                }}
                startIcon={<DownloadIcon />}
              >
                {t("Open this place in PointGenie")}
              </Button>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", color: palette.textMuted }}>
                <AppleIcon sx={{ fontSize: 22 }} />
                <AndroidIcon sx={{ fontSize: 22 }} />
                <Typography sx={{ fontFamily: "Roboto", fontSize: "13px", fontWeight: 800 }}>
                  {t("iPhone & Android")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {utilityDetails.length > 0 && (
          <Box sx={{ px: 2, mt: "14px" }}>
            <Typography sx={{ fontSize: "18px", fontFamily: "Roboto", fontWeight: 700, color: palette.textPrimary, mb: "10px" }}>
              {t("Details")}
            </Typography>
            <Box sx={{ border: `1px solid ${palette.border}`, borderRadius: "18px", backgroundColor: palette.card, overflow: "hidden" }}>
              {utilityDetails.map((row, index) => (
                <Box
                  key={row.title}
                  onClick={() => row.url && window.open(row.url, row.url.startsWith("tel:") ? "_self" : "_blank")}
                  sx={{ display: "flex", alignItems: "center", gap: "12px", p: "14px", cursor: row.url ? "pointer" : "default", borderBottom: index !== utilityDetails.length - 1 ? `1px solid ${palette.border}` : "none" }}
                >
                  <Box sx={{ width: 38, height: 38, borderRadius: "12px", backgroundColor: palette.surfaceMuted, display: "flex", alignItems: "center", justifyContent: "center", flex: "0 0 auto" }}>
                    {row.icon}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontFamily: "Roboto", fontWeight: 700, color: palette.textPrimary, fontSize: "14px" }}>{row.title}</Typography>
                    <Typography sx={{ fontFamily: "Roboto", fontWeight: 500, color: palette.textMuted, fontSize: "13px", mt: "3px", overflowWrap: "anywhere" }}>{row.subtitle}</Typography>
                  </Box>
                  {row.url && <OpenInNewIcon sx={{ fontSize: 18, color: palette.textMuted }} />}
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {getBusinessData?.reviews?.length > 0 && (
          <Box sx={{ px: 2, mt: "14px" }}>
            <Box sx={{ border: `1px solid ${palette.border}`, borderRadius: "18px", backgroundColor: palette.card, overflow: "hidden" }}>
              <Box sx={{ minHeight: 56, px: "14px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `1px solid ${palette.border}` }}>
                <Typography sx={{ fontSize: "16px", fontFamily: "Roboto", fontWeight: 700, color: palette.textPrimary }}>
                  {t("Latest Reviews")} ({reviewCount || getBusinessData.reviews.length})
                </Typography>
                {hasRating && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <StarRoundedIcon sx={{ color: "#F59E0B", fontSize: 18 }} />
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: palette.textSecondary }}>{parseFloat(getBusinessData.rating).toFixed(1)}</Typography>
                  </Box>
                )}
              </Box>
              <Box sx={{ p: "14px", display: "flex", flexDirection: "column", gap: "14px" }}>
                {getBusinessData.reviews
                  .slice(0, showAllReviews ? getBusinessData.reviews.length : 3)
                  .map((review, index) => {
                    const name = review.name || t("User");
                    const initials = name
                      .split(" ")
                      .filter(Boolean)
                      .slice(0, 2)
                      .map((part) => part[0])
                      .join("")
                      .toUpperCase();
                    return (
                      <Box key={index} sx={{ display: "flex", gap: "12px" }}>
                        <Box sx={{ width: 38, height: 38, borderRadius: "50%", backgroundColor: palette.surfaceMuted, color: palette.textSecondary, fontSize: "13px", fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", flex: "0 0 auto" }}>
                          {initials || "?"}
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: palette.textPrimary }}>{name}</Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                              <StarRoundedIcon sx={{ color: "#F59E0B", fontSize: 15 }} />
                              <Typography sx={{ fontSize: "12px", fontWeight: 700, color: palette.textMuted }}>{Number(review.rating || 0)}</Typography>
                            </Box>
                            {review.created_at && (
                              <Typography sx={{ fontSize: "12px", color: palette.textMuted }}>
                                {new Date(review.created_at).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })}
                              </Typography>
                            )}
                          </Box>
                          <Typography sx={{ mt: "4px", fontSize: "14px", fontFamily: "Roboto", fontWeight: 500, lineHeight: "20px", color: palette.textSecondary, overflowWrap: "anywhere" }}>
                            {review.comment}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                {getBusinessData.reviews.length > 3 && (
                  <Typography onClick={() => setShowAllReviews(!showAllReviews)} sx={{ color: palette.accent, fontSize: "13px", fontWeight: 800, cursor: "pointer", textAlign: "center", pt: "2px" }}>
                    {showAllReviews ? t("Show Less...") : t("View More...")}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <Box sx={{overflowX:"hidden"}}>
      {totalPageLoading ? (
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            // backgroundColor: "#f0f0f0",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "250px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
              borderRadius: "8px",
              "@keyframes shimmer": {
                "0%": { backgroundPosition: "-200% 0" },
                "100%": { backgroundPosition: "200% 0" },
              },
            }}
          />

          {/* Shimmer Text */}
          <Box
            sx={{
              width: "70%",
              height: "20px",
              mt: 4,
              borderRadius: "6px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
            }}
          />

          <Box
            sx={{
              width: "50%",
              height: "20px",
              mt: 2,
              borderRadius: "6px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
            }}
          />

          {/* Shimmer Button */}
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Box
              sx={{
                width: "48%",
                height: "45px",
                mt: 4,
                borderRadius: "8px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
              }}
            />

            <Box
              sx={{
                width: "50%",
                height: "45px",
                mt: 4,
                borderRadius: "8px",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
              }}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "45px",
              mt: 2,
              borderRadius: "8px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
            }}
          />
          <Box
            sx={{
              width: "100%",
              height: "45px",
              mt: 2,
              borderRadius: "8px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
            }}
          />
          <Box
            sx={{
              width: "100%",
              height: "45px",
              mt: 2,
              borderRadius: "8px",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
            }}
          />
        </Box>
      ) : (
        <>
          {renderLandingContent()}
          {false && (
          <>
          <Box sx={{ width: "100%", height: "250px", position: "relative" }}>
            {getBusinessData?.images?.filter((img) => img && img !== "")
              .length > 0 ? (
              <>
                <Box
                  component="img"
                  src={
                    getBusinessData?.images?.filter((img) => img && img !== "")[
                      currentImageIndex
                    ]
                  }
                  sx={{
                    width: "100%",
                    height: "250px",
                    objectFit: "cover",
                  }}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    right: 0,
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    transform: "translateY(-50%)",
                  }}
                >
                  <IconButton
                    onClick={() => handleImageNavigation("prev")}
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: isMobile ? "none" : "flex", // Hides button on mobile
                    }}
                  >
                    <ArrowBackIosIcon />
                  </IconButton>

                  <IconButton
                    onClick={() => handleImageNavigation("next")}
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: isMobile ? "none" : "flex", // Hides button on mobile
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 16,
                    left: 0,
                    right: 0,
                    display: "flex",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  {getBusinessData?.images
                    ?.filter((img) => img && img !== "")
                    .map((_, index) => (
                      <CircleIcon
                        key={index}
                        sx={{
                          fontSize: 8,
                          color:
                            index === currentImageIndex
                              ? "#fff"
                              : "rgba(255, 255, 255, 0.5)",
                          cursor: "pointer",
                        }}
                        onClick={() => setCurrentImageIndex(index)}
                      />
                    ))}
                </Box>
              </>
            ) : null}

            <Box sx={{ position: "absolute", top: "15px", right: "20px" }}>
              <Box
                component="img"
                src={nexticon}
                width={"32px"}
                height={"32px"}
                onClick={handleClick}
                sx={{ cursor: "pointer" }}
              />

              {/* Dropdown Menu */}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)} // Check if dropdown should be open
                onClose={handleClosesocialmedia}
                PaperProps={{
                  sx: {
                    mt: 1,
                    borderRadius: "8px",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    width: "200px",
                    p: "5px",
                  },
                }}
              >
                {/* WhatsApp */}
                <MenuItem
                  onClick={() => handleSocialClick("whatsapp")}
                  sx={{ gap: 1 }}
                >
                  <WhatsAppIcon sx={{ color: "#25D366" }} />
                  <Typography>WhatsApp</Typography>
                </MenuItem>

                {/* Instagram */}
                <MenuItem
                  onClick={() => handleSocialClick("instagram")}
                  sx={{ gap: 1 }}
                >
                  <InstagramIcon sx={{ color: "#E4405F" }} />
                  <Typography>Instagram</Typography>
                </MenuItem>

                {/* Facebook */}
                <MenuItem
                  onClick={() => handleSocialClick("facebook")}
                  sx={{ gap: 1 }}
                >
                  <FacebookIcon sx={{ color: "#E4405F" }} />
                  <Typography>Facebook</Typography>
                </MenuItem>

                {/* Twitter */}
                <MenuItem
                  onClick={() => handleSocialClick("twitter")}
                  sx={{ gap: 1 }}
                >
                  <TwitterIcon sx={{ color: "#1DA1F2" }} />
                  <Typography>Twitter</Typography>
                </MenuItem>

                {/* Telegram */}
                <MenuItem
                  onClick={() => handleSocialClick("telegram")}
                  sx={{ gap: 1 }}
                >
                  <TelegramIcon sx={{ color: "#0088CC" }} />
                  <Typography>Telegram</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Box>

          <Box sx={{ px: "20px", pt: "16px", pb: "22px" }}>
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "Sansita",
                fontWeight: "700",
                lineHeight: "27px",
                pb: "3px",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {getBusinessData?.name || ""}
            </Typography>

            <Grid
              container
              sx={{
                // display: "flex",
                // flexDirection: "row",
                gap: "6px",
                alignItems: "start",
              }}
            >
              <Grid item xs={6.7}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    fontWeight: "400",
                    pl: "2px",
                    //   lineHeight: "25.88",
                    // letterSpacing: "-0.65px",
                    color: "",
                  }}
                >
                  {getBusinessData?.address || ""}
                </Typography>
                {getBusinessData?.website && (
                  <Box >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "13px",
                      fontWeight: "400",
                      letterSpacing: "0px",
                      lineHeight: "14px",
                      pt: "5px",
                      pl: "4px",
                      color: "#0041A8",
                    }}
                  >
                    <a
                      href={getBusinessData?.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                       <LanguageIcon
                         sx={{ color: "#0041A8",fontSize:"18px",mr:"4px" }}
                        />
                       {t("Website")}
                    </a>
                  </Typography>
                </Box>
                )}
                {getBusinessData.telephone &&(
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    pt: "3px",
                    paddingLeft: "4px",
                  }}
                >
                  <PhoneIcon
                    fontSize="14px"
                    sx={{ marginRight: "6px", color: "#0041A8" }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "12px",
                      fontFamily: "Roboto",
                      lineHeight: "14px",
                      letterSpacing: "0px",
                      color: "#0041A8",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(`tel:${getBusinessData.telephone}`)
                    }
                  >
                    {getBusinessData?.telephone || ""}
                  </Typography>
                </Box>
                 )}
              </Grid>

              <Grid item xs={5}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    // paddingTop: "6px",
                  }}
                >
                  {getBusinessData?.rating && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "center",
                        flexDirection:'column',
                        gap: "2px",
                      }}
                    >
                      {/* <Box component="img" src={menustar} /> */}
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          // lineHeight: "25.88px",
                          letterSpacing: "-0.65px",
                          color: "#F97731",
                          display: "flex",
                          alignItems: "center", // Use 'center' instead of 'start' for better vertical alignment
                          gap: "5px", 
                        }}
                      >
                        {getBusinessData?.rating &&
                          (parseFloat(getBusinessData.rating) % 1 === 0
                            ? `${parseFloat(getBusinessData.rating).toFixed(1)}`
                            : getBusinessData.rating)}

                        <Rating
                          value={parseFloat(getBusinessData.rating)}
                          readOnly
                          precision={0.1}
                          sx={{ fontSize: "12px" }}
                        />
                          </Typography>
                        <Box
                          component="span"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            fontFamily: "Roboto",
                            // lineHeight: "25.88px",
                            letterSpacing: "-0.3px",
                            color: "#454343",
                            paddingLeft: `${
                              formatReviewCount(getBusinessData?.review_count).length === 4 ? '4px' : '9px'
                            }`,
                          }}
                        >
                          ({formatReviewCount(getBusinessData?.review_count)} reviews)

                        </Box>
                    
                    </Box>
                  )}
                  {/* <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "700",
                      lineHeight: "16px",
                      color: getBusinessData?.is_open_now
                        ? "#53A557"
                        : "#FF0000",
                      py: "3px",
                    }}
                  >
                    {getBusinessData?.is_open_now ? "Open Now" : ""}
                  </Typography> */}
                  {
                  getBusinessData?.start_end_time ? (
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "18px",
                         color: getBusinessData?.start_end_time ==="Closed" ? "gray":"green",
                        textAlign: "center",
                      }}
                    >
                      {getBusinessData.start_end_time}
                    </Typography>
                  ) : null}{" "}
                </Box>
              </Grid>
            </Grid>
          </Box>
          {getBusinessData.business_categories > 0 && (
            <Box sx={{ display: "flex", gap: "8px", px: "20px" }}>
              <Box sx={{ width: "50%" }} pb={"8px"}>
                <Button
                  sx={{
                    border: "1px solid #0041A8",
                    borderRadius: "8px",
                    backgroundColor: "#0041A8",
                    width: "100%",
                    fontSize: "12Px",
                    lineHeight: "14px",
                    fontWeight: "400",
                    fontFamily: "Roboto",
                    textTransform: "capitalize",
                    color: "#FFFFFF",
                    py: "12px",
                  }}
                  onClick={() => navigate(`/menu/${code}`)}
                >
                {t("Check Menu")}
                </Button>
              </Box>

              <Box sx={{ width: "50%" }} pb={"8px"}>
                <Button
                  sx={{
                    border: "1px solid #0041A8",
                    borderRadius: "8px",
                    width: "100%",
                    fontSize: "12Px",
                    lineHeight: "14px",
                    fontWeight: "600",
                    fontFamily: "Roboto",
                    color: "#0041A8",
                    textTransform: "capitalize",
                    py: "12px",
                  }}
                  onClick={() => navigate(`/offers/${code}`)}
                >
                   {t("Offers")}
                </Button>
              </Box>
            </Box>
          )}
         { getBusinessData?.provider?.google &&(
         <Box sx={{ textAlign: "center", pb: "25px", px: "20px" }}>
            <Button
              sx={{
                color: "white",
                width: "100%",
                fontSize: "12px",
                fontFamily: "Roboto",
                fontWeight: "500",
                backgroundColor: "#0041A8",
                textTransform: "capitalize",
                borderRadius: "8px",
                py: "8px",
              }}
              onClick={()=>handleGoogleProviderClick()}
             
            >
              <img
                src={google}
                alt="Google"
                style={{ width: "28px", height: "auto", marginRight: "12px" }}
              />
               {t("Leave us a Google Review")}
            </Button>
          </Box>
           )}

          <Box sx={{ px: "20px", pb: "24px" }}>
            <Box
              sx={{
                border: "1px solid #D8E4FF",
                borderRadius: "8px",
                backgroundColor: "#F6F9FF",
                p: "12px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box
                component="img"
                src={grouplogo}
                alt="PointGenie"
                sx={{ width: "36px", height: "36px", flex: "0 0 auto" }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 700,
                    fontSize: "13px",
                    lineHeight: "16px",
                    color: "#1F2937",
                  }}
                >
                  {t("See this place live in PointGenie")}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: "11px",
                    lineHeight: "14px",
                    color: "#667085",
                    mt: "2px",
                  }}
                >
                  {t("Check the vibe, live updates, nearby hotspots, and rewards.")}
                </Typography>
              </Box>
              <Button
                onClick={handlePointGenieAppClick}
                sx={{
                  backgroundColor: "#0041A8",
                  borderRadius: "8px",
                  color: "#fff",
                  fontFamily: "Roboto",
                  fontWeight: 700,
                  fontSize: "11px",
                  lineHeight: "13px",
                  textTransform: "none",
                  minWidth: "82px",
                  px: "10px",
                  py: "9px",
                  "&:hover": {
                    backgroundColor: "#003487",
                  },
                }}
              >
                {t("Open")}
              </Button>
            </Box>
          </Box>

          {getBusinessData?.provider && (
          <Box sx={{ px: "35px", textAlign: "center", mb: 3 }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                fontFamily: "Roboto",
                lineHeight: "14px",
              }}
            >
             {t(
                  "Connect With Us and Share Your Feedback Your Opinion Matter to Us!"
                )}
            </Typography>
          </Box>
       )}
          {/* Providers Section */}

          {getBusinessData?.provider &&
            (() => {
              const validProviders = Object.entries(getBusinessData.provider)
                .filter(
                  ([provider, data]) =>
                    data.proivder_link && provider.toLowerCase() !== "google"
                )
                .map(([provider, data]) => {
                  let providerIcon;
                  let providerName = data.proivder_label; // Use the label from data
                  let providerUrl = data.proivder_link; // Use the link from data

                  if (provider.toLowerCase() === "yelp") {
                    providerIcon = (
                      <StarIcon sx={{ color: "#D32323", fontSize: 30 }} />
                    );
                  } else if (provider.startsWith("customprovider_")) {
                    providerIcon = (
                      <InsertLinkIcon sx={{ color: "#0041A8", fontSize: 30 }} />
                    );
                  } else {
                    switch (provider.toLowerCase()) {
                      case "facebook":
                        providerIcon = (
                          <FacebookIcon
                            sx={{ color: "#1877F2", fontSize: 30 }}
                          />
                        );
                        break;
                      case "instagram":
                        providerIcon = (
                          <InstagramIcon
                            sx={{ color: "#E4405F", fontSize: 30 }}
                          />
                        );
                        break;
                      case "tiktok":
                        providerIcon = (
                          <Box
                            component="img"
                            src={TIKTOK}
                            sx={{ width: 30, height: 30 }}
                          />
                        );
                        break;
                      case "whatsapp":
                        providerIcon = (
                          <WhatsAppIcon
                            sx={{ color: "#25D366", fontSize: 30 }}
                          />
                        );
                        break;
                      case "tripadvisor":
                        providerIcon = (
                          <StarIcon sx={{ color: "#00AF87", fontSize: 30 }} />
                        );
                        break;
                      case "pointgenie":
                        providerIcon = (
                          <Box
                            component="img"
                            src={grouplogo}
                            sx={{ width: 30, height: 30 }}
                          />
                        );
                        break;
                      default:
                        return null;
                    }
                  }

                  return { provider, providerUrl, providerIcon, providerName };
                })
                .filter(Boolean);

              // Group providers into pairs
              const pairs = [];
              for (let i = 0; i < validProviders.length; i += 2) {
                pairs.push(validProviders.slice(i, i + 2));
              }

              return pairs.map((pair, index) => (
                <Grid
                  container
                  key={index}
                  sx={{ px: "20px", mb: "5px", gap: "4px" }}
                >
                  {pair.map((item) => (
                    <Grid
                      item
                      xs={
                        (pair.length === 1 && validProviders.length > 2) ||
                        validProviders.length === 1
                          ? 12
                          : 5.9
                      }
                      key={item.provider}
                      sx={{
                        border: "1px solid #0041A8",
                        borderRadius: "8px",
                        py: "2px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        gap: "6px",
                      }}
                      onClick={() => handleProviderClick(item)}
                      
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {item.providerIcon}
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "700",
                          fontFamily: "Roboto",
                          lineHeight: "14px",
                          color: "#0041A8",
                        }}
                      >
                        {item.providerName}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              ));
            })()}

          <Box sx={{ px: "10px", pt: "20px", position: "relative" }}>
        
            {getBusinessData?.reviews?.length > 0 && (
              <>
              <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: "400px",
                fontSize: "14px",
                lineHeight: "16px",
                textAlign: "center",
                pt: "4px",
                pb: "5px",
                borderBottom: "1px solid #b7b7b761",
              }}
              >
              {t("Latest Reviews")}
              </Typography>
              <Box sx={{ position: "relative", minHeight: "200px" }}>
                {getBusinessData.reviews
                  .slice(0, showAllReviews ? getBusinessData.reviews.length : 3)
                  .map((review, index) => (
                    <Box
                      key={index}
                      sx={{ p: "10px", borderBottom: "1px solid #ddd" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          lineHeight: "16px",
                        }}
                      >
                        {review.name}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          pt: "6px",
                          pb: "4px",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "4px" }}>
                          {[...Array(5)].map((_, starIndex) => (
                            <Box
                              key={starIndex}
                              component="img"
                              src={menustar}
                              sx={{
                                filter:
                                  starIndex < review.rating
                                    ? "none"
                                    : "grayscale(100%)",
                                opacity: starIndex < review.rating ? 1 : 0.5,
                              }}
                            />
                          ))}
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "400",
                            fontFamily: "Roboto",
                            lineHeight: "16px",
                            color: "#8F9BB3",
                          }}
                        >
                          {new Date(review.created_at).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          lineHeight: "20px",
                        }}
                      >
                        {review.comment}
                      </Typography>
                    </Box>
                  ))}

                {getBusinessData.reviews.length > 1 && (
                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <Typography
                      onClick={() => setShowAllReviews(!showAllReviews)}
                      sx={{
                        color: "#0041A8",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        pb: "25px",
                      }}
                    >
                      {showAllReviews ?  t("Show Less...") : t("View More...")}
                    </Typography>
                  </Box>
                )}
              </Box>
              </>
            )}
          </Box>
        </>
          )}
        </>
      )}

    </Box>
  );
}

export default LandingPage;
